/**
 * Static plan display metadata — actual limits come from the backend (DB-driven).
 * This file only holds display constants: colors, CTA text, icons.
 */

import type { PlanTier } from "@/lib/types";

export const PLAN_COLORS: Record<PlanTier, { bg: string; text: string; border: string; badge: string }> = {
  free: {
    bg: "bg-slate-50",
    text: "text-slate-700",
    border: "border-slate-200",
    badge: "bg-slate-100 text-slate-600",
  },
  pro: {
    bg: "bg-brand-50",
    text: "text-brand-700",
    border: "border-brand-200",
    badge: "bg-brand-100 text-brand-700",
  },
  business: {
    bg: "bg-amber-50",
    text: "text-amber-700",
    border: "border-amber-200",
    badge: "bg-amber-100 text-amber-700",
  },
  enterprise: {
    bg: "bg-purple-50",
    text: "text-purple-700",
    border: "border-purple-200",
    badge: "bg-purple-100 text-purple-700",
  },
};

export const PLAN_CTA: Record<PlanTier, string> = {
  free: "Current plan",
  pro: "Upgrade to Pro",
  business: "Upgrade to Business",
  enterprise: "Contact sales",
};

export const PLAN_DISPLAY_NAMES: Record<PlanTier, string> = {
  free: "Free",
  pro: "Pro",
  business: "Business",
  enterprise: "Enterprise",
};

export function formatPrice(cents: number | null): string {
  if (cents === null || cents === 0) return "Free";
  return `$${(cents / 100).toFixed(0)}`;
}

export function formatLimit(value: number | null): string {
  if (value === null) return "Unlimited";
  return value.toLocaleString();
}

export function formatBytes(bytes: number | null): string {
  if (bytes === null) return "Unlimited";
  if (bytes >= 1073741824) return `${(bytes / 1073741824).toFixed(0)} GB`;
  if (bytes >= 1048576) return `${(bytes / 1048576).toFixed(0)} MB`;
  return `${(bytes / 1024).toFixed(0)} KB`;
}
